const s = {
  name: "Boombox",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,12H4v-2h16V12z"/>
		<path class="st0" d="M22,12h10v-2H22V12z"/>
		<path class="st0" d="M35,12.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2C33.8,11.7,34.3,12.2,35,12.2z"/>
		<path class="st0" d="M8,25.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S6.8,23.3,6.8,24C6.8,24.7,7.3,25.2,8,25.2z"/>
		<path class="st0" d="M8,19c-2.8,0-5,2.2-5,5s2.2,5,5,5c2.8,0,5-2.2,5-5S10.8,19,8,19z M5,24c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3
			S5,25.7,5,24z"/>
		<path class="st0" d="M33.2,24c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S33.2,23.3,33.2,24z"/>
		<path class="st0" d="M27,24c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S27,26.8,27,24z M32,21c-1.7,0-3,1.3-3,3s1.3,3,3,3
			c1.7,0,3-1.3,3-3S33.7,21,32,21z"/>
		<path class="st0" d="M18,25h4v-2h-4V25z"/>
		<path class="st0" d="M4,0h32v6h1c1.7,0,3,1.3,3,3v22c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V9c0-1.7,1.3-3,3-3h1V0z M34,2H6v4h28V2z
			 M3,8C2.4,8,2,8.4,2,9v5h36V9c0-0.6-0.4-1-1-1H3z M2,16v15c0,0.6,0.4,1,1,1h11V16H2z M16,32h8v-3h-8V32z M16,16v3h8v-3H16z M26,32
			h11c0.6,0,1-0.4,1-1V16H26V32z M16,27h8v-6h-8V27z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Boombox
};
